export enum enumOcrStatus {
  PROCESSING,
  PROCESSED,
  PARTIALLY_PROCESSED,
  EXTRACTION_FAILED,
  REVIEWED,
  CANCELED,
  CONVERTING_FILE_TO_IMAGE,
  EXTRACTING_DATA,
  CLASSIFYING_LINE_ITEMS,
}
